// extracted by mini-css-extract-plugin
export default {"bartender":"V2Wco___Bartender-module__bartender"};